var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.0249 8.64447C17.5923 8.64447 17.0191 8.63489 16.3055 8.63489C14.5653 8.63489 13.1343 7.19452 13.1343 5.43789V2.35589C13.1343 2.11343 12.9407 1.91602 12.7007 1.91602L7.63165 1.91602C5.26604 1.91602 3.354 3.8576 3.354 6.23714L3.354 16.5632C3.354 19.0596 5.35713 21.0827 7.82902 21.0827H15.3775C17.7346 21.0827 19.6457 19.1536 19.6457 16.7721V9.07572C19.6457 8.83231 19.453 8.63585 19.212 8.63681C18.8068 8.63968 18.321 8.64447 18.0249 8.64447Z",
    fill: "#136BFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.4137 2.45966C15.1272 2.16162 14.627 2.36671 14.627 2.77975V5.30687C14.627 6.36679 15.5 7.23887 16.5599 7.23887C17.2279 7.24654 18.1555 7.24846 18.9433 7.24654C19.3467 7.24558 19.5518 6.76354 19.272 6.47221C18.261 5.42091 16.4507 3.53683 15.4137 2.45966Z",
    fill: "#136BFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59972 10.9133H11.8437C12.2376 10.9133 12.5576 10.5942 12.5576 10.2003C12.5576 9.80641 12.2376 9.48633 11.8437 9.48633H8.59972C8.20584 9.48633 7.88672 9.80641 7.88672 10.2003C7.88672 10.5942 8.20584 10.9133 8.59972 10.9133ZM8.59983 15.6994H13.817C14.2109 15.6994 14.531 15.3803 14.531 14.9864C14.531 14.5925 14.2109 14.2724 13.817 14.2724H8.59983C8.20596 14.2724 7.88683 14.5925 7.88683 14.9864C7.88683 15.3803 8.20596 15.6994 8.59983 15.6994Z",
    fill: "#136BFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.ab12fa5482744cb1efa9215ce99f3d36.svg";
export { ForwardRef as ReactComponent };